import React from "react";

import loadingSpinner from "../../../assets/loadingSpinners/Loading_Spinner_TransparentBg_v01_75x75.gif";
import "./loadingOverlay.scss";

/**
 * Polished, non-layout-shifting loading overlay.
 *
 * Renders an absolutely-positioned (or fixed) translucent layer with a centered
 * gradient card — so the content underneath keeps its size and nothing "jumps"
 * when loading finishes. Drop it inside a `position: relative` parent.
 *
 * Props:
 *  - show:     boolean — render or not (returns null when false)
 *  - title:    main line (default "Loading…")
 *  - subtitle: optional secondary line
 *  - fixed:    centre in the viewport instead of the parent box
 *  - minHeight: overlay min-height when absolute (default "50vh") so it reads
 *               mid-screen even before any content has height
 */
export default function LoadingOverlay({
  show = true,
  title = "Loading…",
  subtitle,
  fixed = false,
  minHeight = "50vh",
}) {
  if (!show) return null;

  return (
    <div
      className={`loading-overlay${fixed ? " loading-overlay--fixed" : ""}`}
      style={fixed ? undefined : { minHeight }}
      role="status"
      aria-live="polite"
    >
      <div className="loading-overlay__card">
        <span className="loading-overlay__glow" />
        <img
          className="loading-overlay__spinner"
          src={loadingSpinner}
          alt=""
          aria-hidden="true"
        />
        <div className="loading-overlay__text">
          <h5 className="loading-overlay__title">{title}</h5>
          {subtitle && <p className="loading-overlay__subtitle">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
}
